import { Component, OnInit, ChangeDetectionStrategy, AfterContentInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from "../../../reducers";
import { Observable } from "rxjs";
import { CheckoutActions } from "../checkout.actions";
import { Event } from "../../../models";

import { Customer, Address, DisplayShoppingCart, Order } from "../../../models"
import { OrderApi } from "../../../services/webservice"

@Component({
	template: `
	<div class="container--margin-top">
		<complete-payment-presentation
		[order] = "order$ | async"
		(completePayment) = "completePayment($event)"
		(delayPayment) = "delayPayment($event)"
				></complete-payment-presentation>
	</div>`,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompletePaymentComponent implements OnInit, AfterViewInit {
	private order$: Observable<Order>;
	private event$: Observable<Event>;

	constructor(
		private store$: Store<AppState>,
		private router: Router,
		private orderApi: OrderApi,
		private checkoutActions: CheckoutActions
	) { }

	ngOnInit() {
		this.order$ =  this.store$.select("checkout", "lastPlacedOrder").filter(order => order != null)
		this.event$ = this.store$.select("eventServerState", "event", "currentEvent");
	}

	ngAfterViewInit() {
	}

	private completePayment(orderUUID) {
		this.store$.dispatch(this.checkoutActions.completePayment(orderUUID))
	}

	private delayPayment(orderUUID) {
		this.store$.dispatch(this.checkoutActions.delayPayment());
	}
}



// WEBPACK FOOTER //
// ./src/app/components/checkout-components/complete-payment/complete-payment.component.ts